const IdentityVerificationForm = ({identityVerification, ...props}) => {
  return identityVerification.renderForm(props);
};

export default IdentityVerificationForm;
